
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m11.9996 21c-.1834 0-.3668-.0579-.5194-.1738l-.4425-.336c-4.06402-3.0796-6.51673-4.939-7.9445-7.4197-1.36886-2.3705-1.20443-4.24289-.82701-5.39548.46022-1.40075 1.49546-2.52804 2.91757-3.17451.73118-.33136 1.52623-.50051 2.36033-.50051 1.76403 0 3.39441.73572 4.45561 1.94875 1.0613-1.21303 2.6905-1.94875 4.4557-1.94875.8341 0 1.628.168 2.3591.49936 1.4222.64649 2.4586 1.77266 2.9188 3.17451.3786 1.15164.5419 3.02383-.827 5.39543-1.4292 2.4806-3.8853 4.3425-7.9542 7.4266l-.4319.3302c-.1538.1159-.3372.1739-.5206.1739z","fill":"#4a3428"}})])
          )
        }
      }
    